import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../../../style/colors';
import { ITheme } from '../../../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  wrapper: {
    borderRadius: 16,
    boxShadow: '0px 6px 12px rgb(27 27 28 / 15%)',
    '&:hover': {
      boxShadow: '0px 8px 24px rgba(27, 27, 28, 0.15)',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  root: () => ({
    width: '350px',
    border: 0,
    boxShadow: 'none',
    fontFamily: 'DM Serif Display',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    backgroundColor: colors.white,
    borderRadius: '16px 16px 0px 0px',
    boxSizing: 'border-box',
  }),
  cardHeader: {
    display: 'flex',
    placeContent: 'space-between',
  },
  cardContent: {
    flexDirection: 'column',
    placeContent: 'space-evenly',
    height: 180,
  },
  cardDescription: {
    display: 'flex',
    placeItems: 'start',
    padding: '16px 0',
  },
  descriptionTitle: {
    fontWeight: 700,
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(780)]: {
      display: 'block',
    },
  },
  descriptionContent: {
    padding: '0 16px',
    width: '230px',
  },
  languageWrapper: {
    display: 'flex',
    placeItems: 'center',
  },
  language: {
    fontWeight: 700,
    paddingLeft: theme.spacing(1),
  },
  pdfPreviewWrapper: {
    height: 55,
    width: 350,
    textAlign: 'center',
    borderTop: 'none',
    backgroundColor: colors.lightBlue,
    borderRadius: '0 0 16px 16px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  linkLabel: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    paddingRight: 24,
    alignItems: 'center',
  },
  linkContainer: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      '& $previewIcon': {
        opacity: 1,
        marginLeft: '-15px',
        transition: 'all .3s ease-out',
      },
    },
  },
  previewIcon: {
    opacity: 0,
    marginLeft: '-20px',
  },
  pdfPreviewContainer: {
    margin: '64px 40px 32px 40px',
    height: '100%',
  },
  closeButton: {
    cursor: 'pointer',
    position: 'absolute',
    border: 'none',
    background: 'transparent',
    top: 24,
    right: 38,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    color: colors.darkestBlue,

    '&:hover': {
      opacity: 0.8,
    },
  },
  closeIcon: {
    marginRight: theme.spacing(2),
  },
  exerciseIcon: {
    padding: '15px',
    backgroundColor: colors.lightBlue,
    borderRadius: '8px',
  },
}));
